import { render, staticRenderFns } from "./Collingwood.vue?vue&type=template&id=635875ee&scoped=true&"
import script from "./Collingwood.vue?vue&type=script&lang=js&"
export * from "./Collingwood.vue?vue&type=script&lang=js&"
import style0 from "./Collingwood.vue?vue&type=style&index=0&id=635875ee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635875ee",
  null
  
)

export default component.exports